import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import { BarChart } from "@mui/x-charts/BarChart";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import HttpService from "../services/HttpService";
import Labels from "../labels/Labels";

export default function DashboardLocations() {
  async function fetchData() {
    const response = await HttpService.getAxiosClient().get(
      window.API_URL + `/locations/dashboard`
    );
    return response;
  }

  const { data, isLoading } = useQuery(["/locations/dashboard"], () =>
    fetchData()
  );

  async function fetchMinimumCardsAvailableAttribute() {
    const response = await HttpService.getAxiosClient().get(
      window.API_URL + `/employer/attributes/MINIMUM_CARDS_AVAILABLE`
    );
    return response;
  }

  const {
    data: dataMinimumCardsAvailable,
    isFetching: isFetchingMinimumCardsAvailable,
    isError: isErrorDataMinimumCardsAvailable,
    //refetch: refetchDataPayCardAsReplacement
  } = useQuery(
    ["minimumCardsAvailable"],
    () => fetchMinimumCardsAvailableAttribute(),
    {
      keepPreviousData: true,
    }
  );

  if (isLoading) return <></>;

  const columns = [
    {
      field: "location",
      headerName: Labels.getLabel(
        "dashboardLocations.column.location",
        "Location"
      ),
      width: 350,
      editable: false,
    },
    {
      field: "available",
      headerName: Labels.getLabel(
        "dashboardLocations.column.availableCards",
        "Available cards"
      ),
      width: 250,
      editable: false,
    },
    {
      field: "assigned",
      headerName: Labels.getLabel(
        "dashboardLocations.column.assignedCards",
        "Assigned cards"
      ),
      width: 250,
      editable: false,
    },
  ];

  let minimumCardsAvailable = 15;
  if (dataMinimumCardsAvailable && dataMinimumCardsAvailable?.data?.value) {
    minimumCardsAvailable = dataMinimumCardsAvailable?.data?.value;
  }

  return (
    <Container maxWidth="xlg" m={0} p={0}>
      <Grid container m={0} p={0}>
        <Grid item xs={12} m={0} p={0}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {Labels.getLabel(
              "dashboardLocations.CardsDistribution",
              "Cards Distribution by Location"
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} m={0} p={0}>
          <Accordion sx={{ width: "100%" }} defaultExpanded>
            <AccordionSummary>
              <Typography variant="h7">
                {Labels.getLabel("dashboardLocations.Available", "Available")}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  lg={6}
                  m={0}
                  p={0}
                  justifyContent="center"
                  alignContent="center"
                >
                  <PieChart
                    series={[
                      {
                        data: data.data.map((item, index) => ({
                          id: index,
                          value: item.available,
                          label: item.location,
                        })),
                      },
                    ]}
                    slotProps={{
                      legend: { hidden: true },
                    }}
                  />
                </Grid>
                <Grid item xs={12} lg={6} m={0} p={0}>
                  <Box
                    sx={{
                      height: 400,
                      width: "100%",
                      "& .low": {
                        backgroundColor: "#ff943975",
                        color: "#1a3e72",
                      },
                    }}
                  >
                    <DataGrid
                      rows={data.data
                        .map((item, index) => ({
                          id: index,
                          location: item.location,
                          available: item.available,
                          assigned: item.assigned,
                        }))
                        .sort((a, b) =>
                          (a.location || "").localeCompare(b.location || "")
                        )}
                      columns={columns}
                      getCellClassName={(params) => {
                        return params?.row?.available <= minimumCardsAvailable
                          ? "low"
                          : "";
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} m={0} p={0}>
                  <BarChart
                    xAxis={[
                      {
                        scaleType: "band",
                        data: data.data.map((item) => item.location),
                      },
                    ]}
                    series={[{ data: data.data.map((item) => item.available) }]}
                    height={350}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </Container>
  );
}
